import { producaov2 as api } from "../../../../services/apis";
import React, { useState, useEffect, useCallback } from "react";
import SemanticDatepicker from "react-semantic-ui-datepickers";
import swal from "sweetalert";
import { Progress, Modal, Icon, Header } from "semantic-ui-react";
import { producaov2 } from "../../../../services/apis";

import {
  SemanticTable,
  Select,
  FieldContainer,
  ModalContentContainer,
} from "./styles";
import { Button } from "semantic-ui-react";
import { datePattern } from "../../../../utils/Utils";
import { Link } from "react-router-dom";

const Curso = (props) => {
  const [titulo, setTitulo] = useState(props.curso.curso.curso);
  const [horario, setHorario] = useState(props.curso.horario);
  const [dataInicio, setDataInicio] = useState(props.curso.data_inicio);
  const [ultimoAcesso, setUltimoAcesso] = useState(props.curso.data_inicio);
  const [validade, setValidade] = useState(props.curso.validade);
  const [dateValidade, setDateValidade] = useState(new Date());
  const [dateValidadeText, setDateValidadeText] = useState("");
  const [status, setStatus] = useState(props.curso.status);
  const [idCurso, setIdcurso] = useState(props.curso.id_curso);
  const [idAluno, setIdAluno] = useState(props.curso.id_pessoa);
  const [progresso, setProgresso] = useState(props.curso.progresso);
  const [porcentagem, setPorcentagem] = useState(props.curso.progresso);
  const [open, setOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpenValidade, setModalOpenValidade] = useState(false);
  const [horarioModalOpen, setHorarioModalOpen] = useState(false);
  const [isPremium, setIsPremium] = useState(false);
  const [isPremium1ano, setIsPremium1ano] = useState(false);

  const [horarioInicio, setHorarioInicio] = useState("");
  const [horarioFim, setHorarioFim] = useState("");

  const statusOptions = [
    "Confirmação de Pagamento",
    "Em Andamento",
    "Concluído",
    "Não Iniciado",
    "Expirado",
    "Estorno",
  ];

  const getDateObj = (curso) => {
    let dataUsed = "";
    if (curso.data_inicio?.includes("00")) {
      dataUsed = curso.data_insert;
    } else {
      dataUsed = curso.data_inicio;
    }

    const dateObj = new Date(dataUsed);
    if (parseInt(curso.doPremium) === 1 && parseInt(curso.id_combo) !== 0) {
      const years = parseInt(curso.id) === 4134 ? 5 : 1;

      dateObj.setFullYear(dateObj.getFullYear() + years);

      if (curso.id_combo == 5132) {
        setIsPremium1ano(true);

        return dateObj;
      }

      setIsPremium(true);

      return dateObj;
    }

    dateObj.setDate(dateObj.getDate() + curso.validade);

    return dateObj;
  };

  const getCursoDate = useCallback((curso) => {
    const dateObj = getDateObj(curso);

    if (dateObj) {
      dateObj.setHours(
        dateObj.getHours() + (6 - dateObj.getTimezoneOffset() / 60)
      );
    }

    const dateValidade = dateObj
      ? new Intl.DateTimeFormat("af").format(dateObj)
      : null;

    const [year, day, month] = (dateValidade || "2001-01-01").split("-");

    return { dateObj, year, day, month };
  }, []);

  useEffect(() => {
    const { dateObj, year, day, month } = getCursoDate(props.curso);
    setTitulo(props.curso.curso.curso);
    // setHorario(props.curso.horario);
    setDataInicio(
      props.curso.data_inicio !== "0000-00-00"
        ? datePattern(props.curso.data_inicio)
        : "sem registro"
    );
    setUltimoAcesso(
      props.curso.ultimo_acesso !== "0000-00-00"
        ? datePattern(props.curso.ultimo_acesso)
        : "sem registro"
    );
    setValidade(
      props.curso.validade !== "0000-00-00"
        ? datePattern(props.curso.validade)
        : "00-00-0000"
    );
    setDateValidade(dateObj);
    setDateValidadeText(`${day}/${month}/${year}`);
    setStatus(props.curso.status);
    setIdcurso(props.curso.id_curso);
    setIdAluno(props.curso.id_pessoa);
    setProgresso(props.curso.progresso);
    setPorcentagem(props.curso.progresso);
  }, [props.curso]);

  useEffect(() => {
    const premiumObj = isPremium
      ? {
          doPremium: 1,
          id_combo: 4134,
        }
      : isPremium1ano
      ? {
          doPremium: 1,
          id_combo: 5132,
        }
      : {
          doPremium: 0,
          id_combo: 0,
        };

    const { dateObj, year, day, month } = getCursoDate({
      ...props.curso,
      ...premiumObj,
    });

    setDateValidade(dateObj);
    setDateValidadeText(`${day}/${month}/${year}`);
  }, [isPremium, isPremium1ano, props.curso]);

  const updateProgresso = async () => {
    try {
      const payloadProgress = {
        id_pessoa: idAluno,
        id_curso: idCurso,
        value: progresso,
      };

      const progressoValue = await api.put(
        "admin/eadaluno/progresso",
        payloadProgress
      );
      setPorcentagem(progressoValue.data.progresso).then(() => {
        swal(
          "Sucesso ao alterar o progresso",
          "Por favor, caso não tenha alterado, faça o reload da página",
          "success"
        );
      });
    } catch {
      swal(
        "Erro ao enviar o progresso",
        "Por favor, verifique se o valor está correto",
        "error"
      );
    }
  };

  const handleSubmit = useCallback(async () => {
    const payloadCer = {
      config: JSON.stringify({
        userId: idAluno,
        courseId: idCurso,
        needRegenerate: true,
      }),
      isListCourse: true,
    };

    try {
      const certificado = await producaov2.post(
        "/admin/certificate",
        payloadCer
      );

      if (certificado.status === 400) {
        swal(
          "Erro ao Gerar o Certificado",
          certificado?.data?.callback,
          "error"
        );
        return;
      }

      window.open(certificado.data.url);
    } catch {
      swal(
        "Erro ao Gerar o Certificado",
        "Por favor, verifique se o curso foi concluido",
        "error"
      );
      return;
    }
  }, [idAluno, idCurso]);

  const updateCurso = async (idAluno, idCurso, payload) => {
    try {
      api
        .put(`admin/eadalunos/${idAluno}/curso/${idCurso}`, payload)
        .then(() => {
          swal(
            "Sucesso ao editar o curso",
            "Por favor, caso não tenha alterado, faça o reload da página",
            "success"
          );
        })
        .catch(() => {
          swal(
            "Erro ao editar o curso",
            "Por favor, insira preencha todos os campos necessários",
            "error"
          );
          return;
        });
    } catch (error) {
      const logs = {
        local: `alunos/detalhes/${idAluno}`,
        texto: `Tentou atualizar os dados do curso (${idCurso}) para o aluno (${idAluno}) - Erro: ${error}`,
      };
      await api.post("system_logs", {
        acao: JSON.stringify(logs),
      });
    }
  };

  const updateCursoValidade = useCallback(
    (valor, validade) => {
      if (validade == "") {
        validade = 180;
      }

      setStatus(valor);
      setValidade(validade);

      const newPayload = {
        validade,
        status: valor,
      };

      updateCurso(idAluno, idCurso, newPayload);
    },
    [idAluno, idCurso]
  );

  const handleValidade = useCallback(
    ({ target: { value } }) => {
      if (isPremium || isPremium1ano) {
        return;
      }

      const dateObj = new Date(
        props.curso.data_inicio !== "0000-00-00"
          ? props.curso.data_inicio
          : props.curso.data_insert
      );

      dateObj.setDate(dateObj.getDate() + Number(value));
      dateObj.setHours(
        dateObj.getHours() + (3 - dateObj.getTimezoneOffset() / 60)
      );

      const newDateValidade = new Intl.DateTimeFormat("af").format(dateObj);

      setValidade(value);
      setDateValidade(dateObj);
    },
    [isPremium, isPremium1ano, validade, dateValidade, props.curso]
  );

  const handleDateValidade = useCallback(
    (e, { value }) => {
      if (isPremium || isPremium1ano) {
        return;
      }

      const startDate = new Date(
        props.curso.data_inicio !== "0000-00-00"
          ? props.curso.data_inicio
          : props.curso.data_insert
      );

      startDate.setHours(0, 0, 0);

      const actualDate = new Date(value);

      actualDate.setHours(0, 0, 0);

      const newValidade = Math.floor(
        (actualDate.valueOf() - startDate.valueOf()) / (24 * 60 * 60 * 1000)
      );
      setValidade(newValidade);
      setDateValidade(value);
    },
    [isPremium, isPremium1ano, validade, dateValidade, props.curso]
  );

  const handleModalClose = useCallback(() => {
    setModalOpen(false);
    updateCursoValidade(validade, status);
  }, [validade, status]);

  const handleModalValidadeClose = useCallback(() => {
    setModalOpenValidade(false);
    // updateCursoValidade(validade, status);
  }, [validade, status]);

  const handleHorarioModalClose = useCallback(() => {
    setHorarioModalOpen(false);
  }, []);

  const handleHorarioInicio = useCallback(
    (e) => {
      const {
        target: { value },
      } = e;

      setHorarioInicio(value);
      setHorario(`${value}-${horario.split("-")[1]}`);
    },
    [horario]
  );

  const handleHorarioFim = useCallback(
    (e) => {
      const {
        target: { value },
      } = e;

      setHorarioFim(value);
      setHorario(`${horario.split("-")[0]}-${value}`);
    },
    [horario]
  );

  const handleAtribuirHorario = useCallback(() => {
    updateCurso(idAluno, idCurso, { horario });
    handleHorarioModalClose();
    swal(
      "Sucesso ao editar o horário de expiração",
      "Por favor, caso não tenha alterado, faça o reload da página",
      "success"
    );
  }, [horario, idAluno, idCurso]);

  const handleRemoverHorario = useCallback(() => {
    setHorarioInicio("");
    setHorarioFim("");
    setHorario("");

    updateCurso(idAluno, idCurso, { horario: "0" });
  }, [horario, idAluno, idCurso]);

  const handlePremium = useCallback(() => {
    if (isPremium) {
      updateCurso(idAluno, idCurso, { id_combo: 0, doPremium: 0 });
      setIsPremium(false);
      return;
    }

    updateCurso(idAluno, idCurso, { id_combo: 4134, doPremium: 1 });
    setIsPremium(true);
  }, [isPremium]);

  const handlePremium1ano = useCallback(() => {
    if (isPremium1ano) {
      updateCurso(idAluno, idCurso, { id_combo: 0, doPremium: 0 });
      setIsPremium1ano(false);
      return;
    }

    updateCurso(idAluno, idCurso, { id_combo: 5132, doPremium: 1 });
    setIsPremium1ano(true);
  }, [isPremium]);

  return (
    <>
      <SemanticTable.Row>
        <SemanticTable.Cell>
          {titulo} [{idCurso}]
        </SemanticTable.Cell>
        <SemanticTable.Cell>{dataInicio}</SemanticTable.Cell>
        <SemanticTable.Cell>
          {ultimoAcesso}
          {/* <Button
            title="Alterar o horário de acesso do curso"
            onClick={() => setHorarioModalOpen(true)}
          >
            {horario !== "0" && horario}
          </Button>
          <Modal
            closeIcon
            open={horarioModalOpen}
            onClose={handleHorarioModalClose}
          >
            <Header icon="calendar" content="Alterar data de expiração" />

            <ModalContentContainer>
              <div>Horários</div>

              <FieldContainer>
                <label>
                  <strong>Horários de Início</strong>
                </label>
                <input
                  type="time"
                  value={horarioInicio}
                  onChange={handleHorarioInicio}
                />
              </FieldContainer>

              <FieldContainer>
                <strong>Horário de Fim</strong>
                <input
                  type="time"
                  value={horarioFim}
                  onChange={handleHorarioFim}
                />
              </FieldContainer>
            </ModalContentContainer>
            <Modal.Actions>
              <Button color="green" onClick={handleAtribuirHorario}>
                <Icon name="checkmark" /> Atribuir horário
              </Button>
              <Button color="red" onClick={handleRemoverHorario}>
                <Icon name="remove" /> Remover horário
              </Button>
            </Modal.Actions>
          </Modal> */}
        </SemanticTable.Cell>
        <SemanticTable.Cell>
          <Select
            title={statusOptions[status]}
            value={status}
            onChange={(e) => updateCursoValidade(e.target.value)}
          >
            {statusOptions.map((text, index) => (
              <option value={index}>{text}</option>
            ))}
          </Select>
        </SemanticTable.Cell>
        <SemanticTable.Cell>
          <Modal
            closeIcon
            open={open}
            trigger={
              <Button title="Alterar progresso do aluno">
                {porcentagem?.toFixed()}%
              </Button>
            }
            onClose={() => setOpen(false)}
            onOpen={() => setOpen(true)}
          >
            <Header icon="percent" content="progresso do aluno" />
            <Modal.Content>
              <div>
                <Progress
                  value={progresso}
                  total="100"
                  progress="percent"
                  indicating
                />
              </div>
              <div>
                <input
                  type="number"
                  value={progresso}
                  onChange={(e) => setProgresso(e.target.value)}
                />
                %
              </div>
            </Modal.Content>
            <Modal.Actions>
              <Button
                color="green"
                onClick={() => {
                  setOpen(false);
                  updateProgresso();
                }}
              >
                <Icon name="checkmark" /> confirmar
              </Button>
              <Button
                color="red"
                onClick={() => {
                  setOpen(false);
                  setProgresso(porcentagem);
                }}
              >
                <Icon name="remove" /> cancelar
              </Button>
            </Modal.Actions>
          </Modal>
        </SemanticTable.Cell>
        <SemanticTable.Cell>
          <Button
            fluid
            title="Clique para editar os detalhes da validade"
            as={Link}
            to={"/admin/alunos/validade-curso"}
            target="_blank"
            rel="noopener noreferrer"
          >
            {props.curso.validadeData?.pessoaCurso?.validade !==
              "Acesso Vitalício" &&
            props.curso.validadeData?.pessoaCurso?.validade
              ? datePattern(props.curso.validadeData?.pessoaCurso?.validade)
              : "Acesso Vitalício"}
          </Button>
        </SemanticTable.Cell>

        <Modal
          closeIcon
          open={modalOpenValidade}
          onClose={handleModalValidadeClose}
        >
          <Header
            icon="calendar"
            content={`Validade do curso ${props.curso.id_curso}`}
          />

          <ModalContentContainer>
            <FieldContainer>
              <label>
                <strong>Validade que está ativa</strong>
              </label>
              <input
                disabled
                value={`${
                  props.curso.validadeData?.pessoaCurso?.validade ===
                  "Acesso Vitalício"
                    ? "Acesso Vitalício"
                    : datePattern(
                        props.curso.validadeData?.pessoaCurso?.validade
                      )
                }`}
              />
            </FieldContainer>

            {props.curso.validadeData && (
              <FieldContainer>
                <label>
                  <strong>Validade do AllIn</strong>
                </label>
                <input
                  disabled
                  value={
                    props.curso?.id_combo === 5132 ||
                    props.curso?.id_combo === 4134
                      ? props.curso.validadeData?.pessoaCurso?.validade ===
                        "Acesso Vitalício"
                        ? "Acesso Vitalício"
                        : datePattern(
                            props.curso.validadeData?.pessoaCurso?.validade
                          )
                      : "sem registro"
                  }
                />
              </FieldContainer>
            )}

            {props.curso.pacoteData && (
              <FieldContainer>
                <label>
                  <strong>Validade do Pacote</strong>
                </label>
                <input
                  disabled
                  value={
                    props.curso.validadeData.pacoteData
                      ? datePattern(
                          props.curso.validadeData?.pacoteData?.validade
                        )
                      : "sem registro"
                  }
                />
              </FieldContainer>
            )}

            {props.curso.cupomData && (
              <FieldContainer>
                <label>
                  <strong>
                    Validade do cupom:{" "}
                    {datePattern(props.curso.validadeData?.cupomData?.cupom)}
                  </strong>
                </label>
                <input
                  disabled
                  value={
                    props.curso.validadeData.cupomData
                      ? datePattern(
                          props.curso.validadeData?.cupomData?.validade
                        )
                      : "sem registro"
                  }
                />
              </FieldContainer>
            )}

            <FieldContainer>
              <label>
                <strong>Validade do Curso</strong>
              </label>
              <input
                disabled
                value={
                  props.curso.validadeData?.pessoaCurso
                    ? props.curso.validadeData?.pessoaCurso?.validade ===
                      "Acesso Vitalício"
                      ? "Acesso Vitalício"
                      : datePattern(
                          props.curso.validadeData?.pessoaCurso?.validade
                        )
                    : "sem registro"
                }
              />
            </FieldContainer>
            <FieldContainer>
              <label>
                <strong>Está extendido?</strong>
              </label>
              <input
                disabled
                value={
                  props.curso.validadeData?.pessoaCurso?.isExtended
                    ? "Sim"
                    : "Não"
                }
              />
            </FieldContainer>
          </ModalContentContainer>
        </Modal>

        <SemanticTable.Cell>
          <Button onClick={() => setModalOpenValidade(true)} icon="save icon">
            Analisar Validade
          </Button>
        </SemanticTable.Cell>

        <SemanticTable.Cell>
          <Button onClick={handleSubmit} icon="save icon">
            Gerar certificado
          </Button>
        </SemanticTable.Cell>

        <SemanticTable.Cell>
          <>
            <Button
              icon="trash icon"
              info="delete"
              title="Excluir matrícula neste curso"
              onClick={() => props.delete()}
            />
          </>
        </SemanticTable.Cell>
        {/* <SemanticTable.Cell>
          <>
            <Button
              icon="chess queen"
              title={
                isPremium1ano
                  ? "Faz parte do premium 1 ANO"
                  : "Não faz parte do premium 1 ANO"
              }
              negative={isPremium1ano}
              onClick={handlePremium1ano}
            />
          </>
        </SemanticTable.Cell> */}
      </SemanticTable.Row>
    </>
  );
};

export default Curso;
